import GenericInput from './generic-input';

export default GenericInput;